import React from 'react'
import _ from 'underscore'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import Select from '../select'
import Input from '../input'
import Textarea from '../textarea'
import SelectTemplate from './select_template'
import SelectCannedReply from './select_canned_reply'
import EmailPreview from './preview'

class EmailComposer extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      preview: false,
      show_cc: false,
      show_bcc: false
    }
  }

  onEdit = () => {
    this.setState({preview: false})
  }

  onToggleCc = () => {
    this.setState({show_cc: !this.state.show_cc})
  }

  onToggleBcc = () => {
    this.setState({show_bcc: !this.state.show_bcc})
  }

  onPreview = () => {
    this.setState({preview: true})
  }

  onSend = () => {
    this.props.onSend()
  }

  onChange = (params = {}) => {
    let email

    if (this.props.email.toJS) {
      email = this.props.email.toJS() || {}
    }
    else {
      email = this.props.email || {}
    }

    email = _.extend(email, params)

    this.props.onChange({
      senders: email.senders || [],
      sender_id: email.sender_id,
      to: email.to || '',
      cc: email.cc || '',
      bcc: email.bcc || '',
      subject: email.subject || '',
      content: email.content || '',
      signature: email.signature
    })
  }

  onSenderChange = (value) => {
    this.onChange({sender_id: value})
  }

  onToChange = (value) => {
    this.onChange({to: value})
  }

  onCcChange = (value) => {
    this.onChange({cc: value})
  }

  onBccChange = (value) => {
    this.onChange({bcc: value})
  }

  onSubjectChange = (value) => {
    this.onChange({subject: value})
  }

  onContentChange = (value) => {
    this.onChange({content: value})
  }

  onInsertCannedReply = (body) => {
    const el = this.contentEl

    if (!el) {
      this.onContentChange(((this.props.email || {}).content || '') + body)
      return
    }

    const start = el.selectionStart
    const end = el.selectionEnd
    const value = el.value
    const next = value.slice(0, start) + body + value.slice(end)

    this.onContentChange(next)

    // Re-place the cursor just after the inserted text once React re-renders.
    const caret = start + body.length
    window.requestAnimationFrame(() => {
      el.focus()
      el.setSelectionRange(caret, caret)
    })
  }

  onTemplateChange = (value) => {
    this.props.onTemplateChange(value)
  }

  render() {
    const email = this.props.email || {}
    const email_senders = email.senders || []
    const email_sender_id = email.sender_id || undefined
    const email_content = email.content || ''
    const email_subject = email.subject || ''
    const email_cc = email.cc || ''
    const email_bcc = email.bcc || ''

    const senderOptions = _.map(email_senders, function(sender) {
      return [sender.user_id, sender.from]
    })

    if (this.state.preview) {
      return (
        <EmailPreview
          email={this.props.email}
          onEdit={this.onEdit}
          onSend={this.onSend}
        />
      )
    }

    return (
      <div className="grid gap-4">
        <div className="grid grid-cols-[72px_minmax(0,1fr)] items-center gap-x-3 gap-y-4">
          <Label className="justify-self-end">From</Label>
          <Select options={senderOptions} value={email_sender_id} onChange={this.onSenderChange}/>
          <Label className="justify-self-end">To</Label>
          <div className="flex items-center gap-2">
            <div className="min-w-0 flex-1">
              <Input type="text" value={email.to} onChange={this.onToChange} placeholder="To"/>
            </div>
            <Button variant="outline" size="sm" onClick={this.onToggleCc}>Cc</Button>
            <Button variant="outline" size="sm" onClick={this.onToggleBcc}>Bcc</Button>
          </div>
          {(this.state.show_cc || email_cc.length > 0) ?
            <React.Fragment>
              <Label className="justify-self-end">Cc</Label>
              <Input type="text" value={email_cc} onChange={this.onCcChange} placeholder="Cc"/>
            </React.Fragment>
            : null
          }
          {(this.state.show_bcc || email_bcc.length > 0) ?
            <React.Fragment>
              <Label className="justify-self-end">Bcc</Label>
              <Input type="text" value={email_bcc} onChange={this.onBccChange} placeholder="Bcc"/>
            </React.Fragment>
            : null
          }
          <Label className="justify-self-end">Subject</Label>
          <Input type="text" value={email_subject} onChange={this.onSubjectChange} placeholder="Subject"/>
          <Label className="justify-self-end self-start pt-3.5">Content</Label>
          <div className="grid gap-2">
            <Textarea rows="15" value={email_content} onChange={this.onContentChange} inputRef={(el) => { this.contentEl = el }} placeholder="Type your message" expands={true}/>
            <p className="text-xs text-muted-foreground">Note: Signature will be auto-appended</p>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <SelectTemplate
              label="Dynamic Template"
              templates={this.props.templates}
              onSelect={this.onTemplateChange}
            />
            <SelectCannedReply onSelect={this.onInsertCannedReply}/>
          </div>
          <div className="ml-auto flex justify-end gap-2">
            <Button size="sm" onClick={this.onPreview}>Preview</Button>
          </div>
        </div>
      </div>
    )
  }
}

export default EmailComposer
